import Vue from "vue";
import App from "./widget/widget";
import NewApp from "./widget/new-widget";
import store from "./widget/store/index";
import numeral from "numeral";
import VueTippy from "vue-tippy";
import VueDragscroll from "vue-dragscroll";
import * as VueGoogleMaps from "vue2-google-maps";
import VModal from "vue-js-modal";
import VuePortal from "@linusborg/vue-simple-portal";
import introJS from 'intro.js';


let VueScrollTo = require("vue-scrollto");

if (document.getElementById("widget")) {
    Vue.component("spinner", require("@widget/components/spinner").default);
    Vue.component("help-tip", require("@widget/components/help-tip").default);
    Vue.component("v-radio", require("@widget/components/ui/v-radio").default);
    Vue.component("icon-arrow", require("@widget/components/icons/icon-arrow").default);
    Vue.component("icon-check", require("@widget/components/icons/icon-check").default);
    Vue.component("icon-close", require("@widget/components/icons/icon-close").default);
    Vue.component("icon-warning", require("@widget/components/icons/icon-warning").default);

    Vue.use(VueGoogleMaps, {});
    Vue.use(VueTippy);
    Vue.use(VueDragscroll);
    Vue.use(VModal);
    Vue.use(VueScrollTo);
    Vue.use(introJS);
    Vue.use(VuePortal, {
        name: "portal"
    });

    Vue.prototype.$widgetConfig = window.widget_config;
    Vue.prototype.$widgetUI = 'OLD-UI'

    Vue.filter("formatNumber", (value, format, prefix) => {
        if (prefix === undefined || prefix === null) {
            prefix = "";
        }
        if (value < 0) {
            return `- ${prefix}${numeral(Math.abs(value)).format(format)}`;
        }

        return `${prefix}${numeral(Math.abs(value)).format(format)}`;
    });

    Vue.filter("price", (value, prefix) => {
        if (prefix === undefined || prefix === null) {
            prefix = "";
        }
        const price = parseFloat(value);
        if (!price) {
            return `${prefix}0.00`;
        }
        if (price < 0) {
            return `- ${prefix}${Math.abs(price).toFixed(2)}`;
        }
        return `${prefix}${price.toFixed(2)}`;
    });

    const widget = new Vue({
        store,
        render: (h) => h(App)
    }).$mount("#widget");
}

if (document.getElementById("new_widget")) {
    Vue.component("spinner", require("@widget/components/spinner").default);
    Vue.component("help-tip", require("@widget/components/help-tip").default);
    Vue.component("v-radio", require("@widget/components/ui/v-radio").default);
    Vue.component("icon-arrow", require("@widget/components/icons/icon-arrow").default);
    Vue.component("icon-check", require("@widget/components/icons/icon-check").default);
    Vue.component("icon-close", require("@widget/components/icons/icon-close").default);
    Vue.component("icon-warning", require("@widget/components/icons/icon-warning").default);

    Vue.use(VueGoogleMaps, {});
    Vue.use(VueTippy);
    Vue.use(VueDragscroll);
    Vue.use(VModal);
    Vue.use(VueScrollTo);
    Vue.use(introJS);
    Vue.use(VuePortal, {
        name: "portal"
    });

    Vue.prototype.$widgetConfig = window.widget_config;
    Vue.prototype.$widgetUI = 'NEW-UI';

    Vue.filter("formatNumber", (value, format, prefix) => {
        if (prefix === undefined || prefix === null) {
            prefix = "";
        }
        if (value < 0) {
            return `- ${prefix}${numeral(Math.abs(value)).format(format)}`;
        }

        return `${prefix}${numeral(Math.abs(value)).format(format)}`;
    });

    Vue.filter("price", (value, prefix) => {
        if (prefix === undefined || prefix === null) {
            prefix = "";
        }
        const price = parseFloat(value);
        if (!price) {
            return `${prefix}0.00`;
        }
        if (price < 0) {
            return `- ${prefix}${Math.abs(price).toFixed(2)}`;
        }
        return `${prefix}${price.toFixed(2)}`;
    });

    const widget = new Vue({
        store,
        render: (h) => h(NewApp)
    }).$mount("#new_widget");
}
